module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/main-visual-22170f15a62e3244dea3102001484a61.jpg";